function cov_fx60l1n9v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Trash.tsx";
  var hash = "8a8450d4317bcca16d0c1d26e0a8d77b9561864c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Trash.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8a8450d4317bcca16d0c1d26e0a8d77b9561864c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_fx60l1n9v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_fx60l1n9v();
var Icon = (cov_fx60l1n9v().s[0]++, {
  name: 'trash',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.33159 3.91996L6.54728 5.75H3C2.30964 5.75 1.75 6.30964 1.75 7C1.75 7.69036 2.30964 8.25 3 8.25H4.27055L5.55392 19.3725C5.74314 21.0124 7.1317 22.25 8.7825 22.25H15.7175C17.3683 22.25 18.7569 21.0124 18.9461 19.3725L20.2294 8.25H21C21.6904 8.25 22.25 7.69036 22.25 7C22.25 6.30964 21.6904 5.75 21 5.75H17.9527L17.1684 3.91996C16.6563 2.72499 15.4813 1.9502 14.1812 1.9502H10.3188C9.01872 1.9502 7.84372 2.72499 7.33159 3.91996ZM10.3188 4.4502C10.0188 4.4502 9.74763 4.62899 9.62945 4.90476L9.2672 5.75H15.2328L14.8706 4.90476C14.7524 4.62899 14.4812 4.4502 14.1812 4.4502H10.3188ZM17.7129 8.25H6.78713L8.03744 19.086C8.0811 19.4644 8.40154 19.75 8.7825 19.75H15.7175C16.0984 19.75 16.4189 19.4644 16.4626 19.086L17.7129 8.25Z\" fill=\"currentColor\"/>"
});
export default Icon;